import { render, staticRenderFns } from "./MovePopUp.vue?vue&type=template&id=9e2c5e30&scoped=true&"
import script from "./MovePopUp.vue?vue&type=script&lang=js&"
export * from "./MovePopUp.vue?vue&type=script&lang=js&"
import style0 from "./MovePopUp.vue?vue&type=style&index=0&id=9e2c5e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2c5e30",
  null
  
)

export default component.exports